














import Vue from "vue";
import InputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";

export default Vue.extend({
    components: {
        InputSelect: InputSelect
    },
    data: function () {
        return {
            pathInStore: "property.constructionPermit.constructionType",
        };
    },
    computed: {
        floodZone: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) || "";
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("all_kind"),
                    "value": "ALL_KIND"
                },
                {
                    "label": this.$t("apartment_building"),
                    "value": "APARTMENT_BUILDING"
                },
                {
                    "label": this.$t("bel_etage"),
                    "value": "BEL_ETAGE"
                },
                {
                    "label": this.$t("bungalow"),
                    "value": "BUNGALOW"
                },
                {
                    "label": this.$t("house"),
                    "value": "HOUSE"
                },
                {
                    "label": this.$t("villa"),
                    "value": "VILLA"
                },
            ];
        }
    },
    methods: {
        updateValue: function (value: string) {
            if (value != "") {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": value});

            } else if (value == "" &&
                this.$store.getters["FormModule/getValue"](this.pathInStore) != null
            ) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            }
        },
    }
});

